// Screen pattern names and icons, shared by the builder and the My Builds drawer.
export const SCREEN_TYPE_OPTIONS = {
  motif: { label: 'Motif', iconUrl: 'https://cdn.shopify.com/s/files/1/0564/1820/5796/files/Motif.webp?v=1773902656' },
  stripes: { label: 'Stripes', iconUrl: 'https://cdn.shopify.com/s/files/1/0564/1820/5796/files/Stripes.webp?v=1773895000' },
  windows: { label: 'Windows', iconUrl: 'https://cdn.shopify.com/s/files/1/0564/1820/5796/files/Windows.webp?v=1773902656' },
  scales: { label: 'Scales', iconUrl: 'https://cdn.shopify.com/s/files/1/0564/1820/5796/files/Scales.webp?v=1773891830' },
  holes: { label: 'Holes', iconUrl: 'https://cdn.shopify.com/s/files/1/0564/1820/5796/files/Holes.webp?v=1773902656' }
}
